import { ReactNode } from "react"
import { Logo } from "../../../themes/saliant/components/Logo"

interface Props {
    children: ReactNode
}

export function PrimaryFeatureFrame({ children }: Props) {
    return (
        <div className="flex aspect-video w-full flex-col bg-gray-100">
            <div className="shadow-b relative flex h-10 border-b-2 border-gray-300/70">
                <div className="items-left justify-left absolute inset-0 flex pl-4">
                    <div className="flex items-center gap-x-2">
                        <div className="h-2.5 w-2.5 rounded-full bg-gray-300"></div>
                        <div className="h-2.5 w-2.5 rounded-full bg-gray-300"></div>
                        <div className="h-2.5 w-2.5 rounded-full bg-gray-300"></div>
                    </div>
                </div>
                <div className="mx-auto mt-3 h-[50%] w-96 rounded-md bg-gray-200 shadow-inner">
                    <div className="flex text-xs leading-5 text-gray-400">
                        <span className="mx-auto text-center">researchwiseai.com</span>
                    </div>
                </div>
            </div>
            <div className="grow bg-gray-200">
                <div className="mt-10 flex h-full overflow-hidden">
                    <div className="w-48 pl-8 text-gray-500">
                        <Logo className="mb-8 h-6 w-auto" />
                        <span className="mb-2 block text-sm font-semibold">Overview</span>
                        <span className="mb-2 block text-sm font-semibold text-primary-600">Projects</span>
                        <span className="mb-2 block text-sm font-semibold">Reports</span>
                        <span className="mb-2 block text-sm font-semibold">Billing</span>
                        <span className="block text-sm font-semibold">Settings</span>
                    </div>
                    <div className="mr-8 grow rounded-lg bg-white shadow">{children}</div>
                </div>
            </div>
        </div>
    )
}
